import { Component, Input } from '@angular/core';
import { DsButtonVariants, DsModalService, DsModule } from '@levelaccess/design-system';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { BusMessageService } from '../../../../services/bus-message.service';
import { CommonPipesModule } from '../../../../shared/common-pipes.module';

@Component({
  selector: 'app-cannot-move-digital-property-modal',
  templateUrl: './cannot-move-digital-property-modal.component.html',
  imports: [DsModule, CommonPipesModule],
  providers: [BusMessageService],
  standalone: true,
})
export class CannotMoveDigitalPropertyModalComponent {
  @Input() reason: string;

  constructor(
    public modal: NgbActiveModal,
    private readonly dsModalService: DsModalService,
  ) {}

  onClose(): void {
    this.dsModalService.closeCurrentModal();
  }

  protected readonly DsButtonVariants: typeof DsButtonVariants = DsButtonVariants;
}
